import React, { createContext, useState, useEffect } from 'react';

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');

  useEffect(() => {
    const storedTheme = localStorage.getItem('theme');
    if (!storedTheme) {
      const darkThemeMq = window.matchMedia('(prefers-color-scheme: dark)');
      const updateTheme = () => {
        const newTheme = darkThemeMq.matches ? 'dark' : 'light';
        setTheme(newTheme);
      };

      updateTheme();
      darkThemeMq.addEventListener('change', updateTheme);

      return () => {
        darkThemeMq.removeEventListener('change', updateTheme);
      };
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('theme', theme);
    document.body.className = '';
    document.body.classList.add(`${theme}-theme`);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};